(function(){
  const SCRIPT_VERSION='1.2.1';
 const BENEFITS=[
  'Flexible Delivery',
  'Update or Cancel Anytime',
  '25% Off Subscription Orders',
  'Free Shipping'
];
  const DISCOUNT_FACTOR=0.75;
  let lastEnhance=0;

  function money(txt){const m=txt?.replace(/,/g,'').match(/([0-9]+\.[0-9]{2})/);return m?parseFloat(m[1]):null;}
  function benefitEl(text){const d=document.createElement('div');d.className='ps-rc-benefit';d.innerHTML='<svg viewBox="0 0 16 16" fill="none"><path fill="currentColor" d="M6.4 11.2 3 7.8l1.12-1.12 2.28 2.28 5.48-5.48L13 4.58 6.4 11.2Z"/></svg>'+text;return d;}

  // Re-reads ReCharge's updated .price-label nodes and syncs to our custom UI elements
  function refreshPrices(root){
    if(!root) return;
    [...root.querySelectorAll('label.rc-radio')].forEach(label=>{
      const priceLabel=label.querySelector('.price-label');
      if(!priceLabel) return;
      const priceFinalEl=label.querySelector('.ps-rc-price-final');
      if(!priceFinalEl) return;
      const finalPrice=priceLabel.textContent.trim();
      if(!finalPrice) return;
      priceFinalEl.textContent=finalPrice;
      const priceOriginalEl=label.querySelector('.ps-rc-price-original');
      if(priceOriginalEl && label.classList.contains('subscription-radio')){
        const f=money(finalPrice);
        if(f) priceOriginalEl.textContent=`$${(f/DISCOUNT_FACTOR).toFixed(2)}`;
      }
    });
  }

  function enhance(root){
    if(!root) return;
    root.classList.add('ps-rc-enhanced');
    const radios=[...root.querySelectorAll('label.rc-radio')];
    if(!radios.length){ return; }

    radios.forEach(label=>{
      const priceLabel=label.querySelector('.price-label');
      const discountLabel=label.querySelector('.discount-label');
      if(!priceLabel||!discountLabel) return;
      if(label.querySelector('.ps-rc-row')) return; // already processed
      const wrapper=document.createElement('div');
      wrapper.className='ps-rc-row';
      const title=document.createElement('div');
      title.className='ps-rc-title';
      title.textContent=discountLabel.textContent.trim();
      let finalPrice=priceLabel.textContent.trim();
      let originalPrice=null;
      if(label.classList.contains('subscription-radio')){
        const f=money(finalPrice);
        if(f){ originalPrice=(f/ DISCOUNT_FACTOR).toFixed(2); }
      }
      const prices=document.createElement('div');
      prices.className='ps-rc-prices';
      if(originalPrice){
        const o=document.createElement('span');
        o.className='ps-rc-price-original';
        o.textContent=`$${originalPrice}`;
        prices.appendChild(o);
      }
      const nf=document.createElement('span');
      nf.className='ps-rc-price-final';
      nf.textContent=finalPrice;
      prices.appendChild(nf);
      wrapper.appendChild(title);
      wrapper.appendChild(prices);
      const container=label.querySelector('.rc-radio__label');
      // Append without clearing — keeps .price-label/.discount-label in DOM (CSS hides them)
      // so ReCharge can still update their text when the variant changes
      if(container){ container.appendChild(wrapper); }
    });

    // Move selling plans + benefits inside subscription card body
    const subscriptionCard=root.querySelector('label.subscription-radio');
    // Ensure subscription card is first
    const optionsContainer=root.querySelector('.rc-button-group__options');
    if(subscriptionCard && optionsContainer && optionsContainer.firstElementChild!==subscriptionCard){
      optionsContainer.insertBefore(subscriptionCard, optionsContainer.firstElementChild);
    }
    if(subscriptionCard){
      // Container for expandable content
      let body=subscriptionCard.querySelector('.ps-rc-body');
      if(!body){
        body=document.createElement('div');
        body.className='ps-rc-body';
        subscriptionCard.appendChild(body);
      }
      const sellingPlans=root.querySelector('.rc-selling-plans');
      if(sellingPlans && !body.contains(sellingPlans)){
        body.appendChild(sellingPlans);
      }
      // Remove bundle plans from selling plans dropdown
      const sellingPlanSelect=body.querySelector('.rc-selling-plans-dropdown__select');
      if(sellingPlanSelect){
        const bundleOptions=[...sellingPlanSelect.querySelectorAll('option')].filter(opt=>opt.textContent.includes('[BUNDLE]'));
        bundleOptions.forEach(opt=>opt.remove());
      }
      if(body && !body.querySelector('.ps-rc-benefits')){
        const benefits=document.createElement('div');
        benefits.className='ps-rc-benefits';
        BENEFITS.forEach(b=>benefits.appendChild(benefitEl(b)));
        body.appendChild(benefits);
      }
    }

    function syncActive(){
      radios.forEach(r=>{
        const input=r.querySelector('input[type=radio]');
        const body=r.querySelector('.ps-rc-body');
        if(input?.checked){
          r.classList.add('rc-radio--active');
          if(body) body.style.display='block';
        } else {
          r.classList.remove('rc-radio--active');
          if(body) body.style.display='none';
        }
      });
    }
    syncActive();
    root.addEventListener('change',e=>{ if(e.target.matches('input[type=radio][name=purchaseOption]')) syncActive(); });
    lastEnhance=Date.now();
  }

  function scan(){
    const w=document.querySelector('.rc-widget');
    if(w) enhance(w);
  }

  function start(){
    scan();
    // When a Shopify variant changes, updateVariantInput() fires a native change event on
    // input[name="id"]. ReCharge hears that and updates its .price-label text in-place.
    // After giving ReCharge time to respond, sync the updated prices into our custom UI.
    document.addEventListener('change',e=>{
      if(!e.target.matches('input[name="id"]')) return;
      const w=document.querySelector('.rc-widget');
      if(!w) return;
      [200,500,1000].forEach(delay=>setTimeout(()=>refreshPrices(w),delay));
    });
    const obs=new MutationObserver(muts=>{
      let relevant=false;
      for(const m of muts){
        if(m.addedNodes.length){
          for(const n of m.addedNodes){
            if(n.nodeType!==1) continue;
            if(n.classList?.contains('rc-widget') || n.querySelector?.('.rc-widget')) { relevant=true; break; }
            if(n.matches?.('.rc-radio, .rc-selling-plans, .rc-button-group__options') || n.querySelector?.('.rc-radio')) { relevant=true; break; }
          }
        }
        if(relevant) break;
      }
      if(relevant) scan();
    });
    obs.observe(document.documentElement,{childList:true,subtree:true});
    setInterval(()=>{ if(Date.now()-lastEnhance>600) scan(); },800);
  }

  if(document.readyState==='complete' || document.readyState==='interactive') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
